module.exports = __webpack_public_path__ + "img/flow-v.943fcb01.svg";